import { useEffect, useState, useCallback, Suspense } from "react";
import { Route, Switch } from "react-router-dom";

import React from "react";

import "./App.css";

import WebFont from "webfontloader";

import MainNavigation from "./UI/Navigation/MainNavigation/MainNavigation";
import Menu from "./pages/Menu/Menu";
import Home from "./pages/HomePage/HomePage";
import Cabinet from "./pages/Cabinet/Cabinet";
import SearchPage from "./pages/Search/SearchPage";
import Cart from "./components/Cart/Cart";
import BookShelfMobile from "./pages/BookShelf/BookShelfMobile";
import BookShelfDesktop from "./pages/BookShelf/BookShelfDesktop";
import HelpPage from "./pages/Help/HelpPage";

import CartProvider from "./store/CartProvider";
import CabinetProvider from "./store/CabinetProvider";
import ShelfProvider from "./store/ShelfProvider";

import { IngredientsProvider } from "./store/IngredientContext";
import { CocktailsProvider } from "./store/CocktailContext";

import useWindowDimensions from "./hooks/useWindowDimensions";

// const Home = lazy(() => import('./pages/HomePage/HomePage'))
// const Menu = lazy(() => import("./pages/Menu/Menu"));
// const Cabinet = lazy(() => import("./pages/Cabinet/Cabinet"));
// const SearchPage = lazy(() => import("./pages/Search/SearchPage"));
// const Cart = lazy(() => import("./components/Cart/Cart"));
// const BookShelfMobile = lazy(() => import("./pages/BookShelf/BookShelfMobile"));
// const BookShelfDesktop = lazy(() =>
//   import("./pages/BookShelf/BookShelfDesktop")
// );
// const HelpPage = lazy(() => import("./pages/Help/HelpPage"));

function App() {
  const [showCart, setShowCart] = useState(false);
  const { width } = useWindowDimensions();


  useEffect(() => {
    function updateVh() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    }

    window.addEventListener("resize", updateVh);
    window.addEventListener("orientationchange", updateVh);

    // Call it once to set on load
    updateVh();

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener("resize", updateVh);
      window.removeEventListener("orientationchange", updateVh);
    };
  }, []);

  const showCartHandler = useCallback(() => {
    setShowCart(true);
  }, []);

  const hideCartHandler = useCallback(() => {
    setShowCart(false);
  }, []);

  return (
    <div className="app_container" style={{ width: "100svw" }}>
      <CartProvider>
        <CabinetProvider>
          <IngredientsProvider>
            <CocktailsProvider>
              <ShelfProvider>
                <MainNavigation showCart={showCartHandler} />
                <Suspense>
                  {showCart && <Cart onClose={hideCartHandler} />}
                  <Switch>
                    <Route path="/menu">
                      <Menu />
                    </Route>
                    <Route path="/search_cocktails">
                      <SearchPage />
                    </Route>
                    <Route path="/cabinet">
                      <Cabinet />
                    </Route>
                    <Route path="/book_shelf">
                      {width >= 800 ? (
                        <BookShelfDesktop />
                      ) : (
                        <BookShelfMobile />
                      )}
                    </Route>
                    <Route path="/help">
                      <HelpPage />
                    </Route>
                    <Route path="/">
                      <Home />
                    </Route>
                  </Switch>
                </Suspense>
              </ShelfProvider>
            </CocktailsProvider>
          </IngredientsProvider>
        </CabinetProvider>
      </CartProvider>
    </div>
  );
}

export default App;
